import { mateListTestIds } from '../../list/MateList/mateList.testIds'

export interface OmniPlayerCountControlProps {
  value: number
  options: number[]
  onChange: (count: number) => void
}

/**
 * OmniPlayerCountControl lets the Omni-mode operator pick how many players to
 * play as, via a dropdown rather than incremental add/remove buttons.
 *
 * Hidden by the caller (not here) whenever `options` has one or zero entries -
 * see mateListVM.ts's playerCountOptions, which already resolves the right set
 * (the active game's own min/max players, or a platform developer's fixed 1-5).
 */
export function OmniPlayerCountControl({ value, options, onChange }: OmniPlayerCountControlProps) {
  return (
    <div className="px-2 py-2 border-b border-basic flex items-center justify-between gap-2" onClick={(e) => e.stopPropagation()}>
      <label htmlFor="omni-player-count" className="text-xs font-medium text-muted">
        Players
      </label>
      <select
        id="omni-player-count"
        data-testid={mateListTestIds.omniPlayerCountSelect}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="text-xs bg-transparent text-primary font-medium focus:outline-none cursor-pointer hover:text-accent border rounded px-1 py-0.5"
      >
        {options.map((n) => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
    </div>
  )
}
